"use strict";
exports.__esModule = true;
exports.ExtraHelper = void 0;
var model_1 = require("../../room/model");
var getCoverImage = function (extra) {
    if (extra.pictures.length) {
        return extra.pictures[0].templates.find(function (t) { return t.name === model_1.RoomTemplateImage.Original; });
    }
    return {};
};
exports.ExtraHelper = { getCoverImage: getCoverImage };
//# sourceMappingURL=extra.helper.js.map